import React from 'react'
import {
  Container,
  YStack,
  SizableText,
  ScrollView,
  Button,
  SmartLink,
  TextLink,
  XStack,
  Spinner,
} from '@my/ui'
import { Logo, MainLayout, Meta } from 'app/components'
import { HotGroupsQueryOutput } from './queries'
import { GroupCardHorizontal } from '../../containers'

export interface GroupsFeedLoggedOutScreenProps {
  HeaderComponent?: React.ReactNode
  groups: HotGroupsQueryOutput['searchGroups']['docs']
  groupsLoading: boolean
}

const NoAccess = ({ showLogo = true }) => {
  return (
    <Container gap="$3.5" ai="center" gutter flexShrink={1} flexGrow={1} size="sm">
      {showLogo && <Logo width={90} />}
      <SizableText maxWidth={400} mx="auto" textAlign="center" size="$5" fow="600">
        Join Student Saviour and gain full access to chats, groups, events and more!
      </SizableText>
      <YStack ai="center" gap="$2">
        <SmartLink Component={Button} w={286} href="/sign-up" theme="primary">
          Join now!
        </SmartLink>
        <SizableText fow="400">
          Already have an account?{' '}
          <TextLink fow="600" href="/log-in">
            Log in
          </TextLink>
        </SizableText>
      </YStack>
    </Container>
  )
}

export const GroupsFeedLoggedOutScreen = (props: GroupsFeedLoggedOutScreenProps) => {
  return (
    <MainLayout>
      <Meta
        title="Uni Chat & Groups"
        description="Chat Groups with Friends, Coursemates, Societies etc."
      />
      {props.HeaderComponent && props.HeaderComponent}
      <ScrollView>
        <Container
          flexGrow={1}
          gap="$4"
          spaceTop
          spaceBottom
          $gtMd={{
            gap: '$6',
          }}
        >
          <NoAccess />
          {!props.groupsLoading && props.groups && props.groups.length > 0 && (
            <Container gap="$3.5" gutter flexShrink={1} flexGrow={1} size="sm">
              <SizableText
                size="$5"
                fow="600"
                $gtMd={{
                  size: '$8',
                  fow: '600'
                }}
  
              >
                Hot Groups
              </SizableText>

              <YStack gap="$3.5">
                {props.groups.map((item) => (
                  <GroupCardHorizontal
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    visibility={item.visibility}
                    totalMembers={item?.totalMembers || 0}
                    href={`/groups/${item.id}`}
                    canJoin={false}
                    hasJoined={false}
                    canLeave={false}
                    profileImage={{
                      url: item.profileImage?.sizes?.medium?.url || '',
                      alt: item.name,
                    }}
                  />
                ))}
              </YStack>
            </Container>
          )}
          {props.groupsLoading && (
            <XStack w="100%" jc="center" ai="center" h={100}>
              <Spinner color="$black" />
            </XStack>
          )}
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
